import React, { useImperativeHandle, useState, forwardRef } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { styled, FormError } from '@goodrx/matisse';
import { useSynapse } from 'app/lib/synaptik';
import { onStripeError, onCreditCardFieldFocused } from 'app/lib/analytics';

const CardWrapper = styled.div`
  .StripeElement {
    border: 1px solid ${(p: any) => p.theme.colors.greyLight};
    padding: 12px;
    border-radius: ${(p: any) => p.theme.radius}px;
    height: 48px;
  }
`;

const baseStyle = {
  base: {
    fontFamily: 'Avenir',
    fontSize: '16px',
    fontWeight: '500',
    fontSmoothing: 'antialiased',
  },
};

export const PaymentForm = forwardRef((_, ref) => {
  const stripe = useStripe();
  const elements = useElements();
  // @ts-ignore
  const [postalCode] = useSynapse(({ user }) => [user.state.profile?.zip]);
  const [stripeError, setStripeError] = useState<string | undefined>();

  useImperativeHandle(
    ref,
    () => ({
      generateCardToken: async () => {
        if (!stripe || !elements) return null;

        const { token, error } = await stripe.createToken(elements.getElement(CardElement)!);

        if (error) {
          onStripeError(error);
          setStripeError(error.message);
        }

        return token?.id;
      },
    }),
    [stripe, elements]
  );

  return (
    <>
      <CardWrapper onFocus={onCreditCardFieldFocused}>
        <CardElement options={{ value: { postalCode }, style: baseStyle }} />
      </CardWrapper>

      {stripeError && <FormError>{stripeError}</FormError>}
    </>
  );
});
